import React, { useEffect, useState } from "react";
// import { NavLink } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import SideMenu from "../../components/menus/m-side";
import { useNavHeight } from "../../__utils/context/navheightprovider";
import tableSaisons from "../../__params/tab-config/tab-saisons";
import tabEnteteMembersCsvFile from "../../__params/tab-pages/members/tab-enteteMembersCsvFiles";
import tabCsvFiles from "../../__params/tab-pages/members/tab-csvFiles";
import Papa from "papaparse";
import FaIcons from "../../assets/icons/faicons";
import MemberSlipModal from "../../components/pages/admin/c-memberslipmodal";

const ListeDesMembres = () => {
  const { navbarHeight } = useNavHeight();
  const [currentSeason, setCurrentSeason] = useState(0);
  // const [tabRows, setTabRows] = useState([]);
  const [tabValues, setTabValues] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [member, setMember] = useState({});

  useEffect(() => {
    let year = 0;

    /*************************** Selection of today's date to select current season year */
    const todaysDate = new Date();
    for (let i = 0; i < tableSaisons.length; i++) {
      const startDate = Date.parse(tableSaisons[i].startDate);
      const endDate = Date.parse(tableSaisons[i].endDate);

      if (todaysDate > startDate && todaysDate < endDate) {
        year = tableSaisons[i].season;
        break;
      }
    }

    /*************************** Display of members list of the current season */
    setCurrentSeason(year);
    const yearIndex = tabCsvFiles.findIndex((item) => item.season === year);
    const csvFile = tabCsvFiles[yearIndex].file;

    Papa.parse(csvFile, {
      download: true,
      header: true,
      dynamicTyping: true,
      delimiter: "",
      skipEmptyLines: true,
      complete: (result) => {
        const rowsArray = [];
        const valuesArray = [];

        result.data.map((d) => {
          return (
            rowsArray.push(Object.keys(d)),
            valuesArray.push(
              Object.values({
                ...d,
                // residence: d.residence.replaceAll(" ", "\u00a0"),
                // street: d.street.replaceAll(" ", "\u00a0"), // \u00a0  refers to the Unicode character of &nbsp;
                // city: d.city.replaceAll(" ", "\u00a0"),
              }),
            )
          );
        });
        // setTabRows(rowsArray[0]);
        setTabValues(valuesArray);
      },
    });
  }, []);

  //
  /* Récupération des saisons présentes dans le fichier des membres */
  //
  const tabSaison = [];
  let season = "";

  tabCsvFiles.map((saison) => {
    if (saison.season !== season) {
      season = saison.season;

      tabSaison.push({ season: saison.season });
    }
    return {
      tabSaison,
    };
  });
  /* FIN - Récupération des saisons existant dans la table des fichiers des membres */

  const handleSeasonChange = (e) => {
    const yearIndex = tabCsvFiles.findIndex(
      (item) => item.season === e.target.value,
    );
    const csvFile = tabCsvFiles[yearIndex].file;

    Papa.parse(csvFile, {
      download: true,
      header: true,
      dynamicTyping: true,
      delimiter: "",
      skipEmptyLines: true,
      complete: (result) => {
        const rowsArray = [];
        const valuesArray = [];

        result.data.map((d) => {
          return (
            rowsArray.push(Object.keys(d)),
            valuesArray.push(
              Object.values({
                ...d,
                // residence: d.residence.replaceAll(" ", "\u00a0"),
                // street: d.street.replaceAll(" ", "\u00a0"), // \u00a0  refers to the Unicode character of &nbsp;
                // city: d.city.replaceAll(" ", "\u00a0"),
              }),
            )
          );
        });

        // setTabRows(rowsArray[0]);
        setTabValues(valuesArray);
      },
    });
    setCurrentSeason(e.target.value);
  };

  const handleShowMember = (value) => (e) => {
    setModalShow(true);
    setMember(value);
  };

  return (
    <div className="mc-fond-clubhouse">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          <Col
            xs={12}
            md={3}
            className="gx-0"
            style={{
              position: "sticky",
              top: navbarHeight,
              zIndex: "1000",
            }}
          >
            <SideMenu />
          </Col>

          <Col xs={12} md={9} className="g-0">
            <Row className="justify-content-center align-items-center text-center text-primary bg-light m-4 p-2 rounded mc-rampart">
              <Col md={9} className="g-0">
                <h1 className="m-0 mc-rfs-1">LISTE DES MEMBRES</h1>
              </Col>
              <Col md={3} className="g-0">
                <Form.Select
                  className="mc-rfs-3 m-auto text-center text-primary bg-secondary-subtle"
                  name="currentSeason"
                  value={currentSeason}
                  onChange={handleSeasonChange}
                >
                  {tabSaison.map((saison, i) => {
                    return <option key={i}>{saison.season}</option>;
                  })}
                </Form.Select>
              </Col>
            </Row>

            <Card bg="transparent" className="my-2 border-0 mc-rfs-5">
              <Card.Body>
                <Table
                  responsive
                  bordered
                  hover
                  striped
                  style={{
                    tableLayout: "fixed",
                    // minWidth: "1000px",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr className="bg-success text-white">
                      <th
                        className="align-middle text-center bg-primary-subtle"
                        style={{ width: "50px" }}
                      >
                        <FaIcons.FaEye />
                      </th>
                      <th
                        className="align-middle text-center bg-primary-subtle"
                        style={{ width: "50px" }}
                      >
                        #
                      </th>
                      {tabEnteteMembersCsvFile.map((entete, i) => {
                        return (
                          <th
                            key={i}
                            className="align-middle text-center bg-primary-subtle"
                            style={{ width: entete.width }}
                          >
                            {entete.label}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody className="bg-success">
                    {tabValues.map((value, i) => {
                      const estTrouve = value.find((val) => val === "Adhérent");
                      return (
                        <tr
                          key={i}
                          className={estTrouve ? "table-success" : ""}
                        >
                          <td
                            className={
                              estTrouve
                                ? "py-0 align-middle text-center text-success"
                                : "py-0 align-middle text-center text-secondary"
                            }
                          >
                            <OverlayTrigger
                              placement={"top"}
                              overlay={
                                <Tooltip className="mc-rfs-7">
                                  Ouvrir la fiche
                                </Tooltip>
                              }
                            >
                              <div
                                className="p-2"
                                style={{ cursor: "pointer" }}
                                onClick={handleShowMember(value)}
                              >
                                <FaIcons.FaEye />
                              </div>
                            </OverlayTrigger>
                          </td>
                          <td
                            className={
                              estTrouve
                                ? "py-0 align-middle text-center text-success"
                                : "py-0 align-middle text-center text-secondary"
                            }
                          >
                            {i + 1}
                          </td>
                          {tabEnteteMembersCsvFile.map((col, index) => {
                            return (
                              <td
                                key={index}
                                className={
                                  estTrouve
                                    ? "py-0 text-success"
                                    : "py-0 text-secondary"
                                }
                                style={{
                                  textAlign: col.textAlign,
                                  verticalAlign: col.verticalAlign,
                                  fontWeight: col.fontWeight,
                                }}
                              >
                                {value[index]}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <MemberSlipModal
        modalShow={modalShow}
        setModalShow={setModalShow}
        member={member}
      />
    </div>
  );
};

export default ListeDesMembres;
